import { makeVar } from '@apollo/client';
import { EnumTaxMethod } from '../../graphql/types';
import { defaultMethod, defaultYear } from './constants';

export const methodVar = makeVar<EnumTaxMethod>(defaultMethod);
export const yearVar = makeVar<number>(defaultYear);
export const initialOptionsSetVar = makeVar<boolean>(false);
export const initialQuerySetVar = makeVar<boolean>(false);
